import { render, staticRenderFns } from "./StudentsDocs.vue?vue&type=template&id=1a81524c&"
import script from "./StudentsDocs.vue?vue&type=script&lang=js&"
export * from "./StudentsDocs.vue?vue&type=script&lang=js&"
import style0 from "./StudentsDocs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports